module.exports = __webpack_public_path__ + "img/15-r.985b5e29.png";